export const menuDetailFeatureTranslationEN = {
  menuDetailFeature: {
    Component: {
      csv_output: 'csv output',
      delete: 'delete',
      close: 'close',
      setting: 'setting',
      search: 'search',
      reload: 'reload',
      detail: 'detail',
      save: 'save',
      change_btn: 'change btn',
    },
    Text: {
      menu_detail_normal: 'menu detail normal',
      all: 'all',
      japanese: 'japanese',
      english: 'english',
      simplified_chinese: 'simplified chinese',
      traditional_chinese: 'traditional chinese',
      korean: 'korean',
      vietnamese: 'vietnamese',
      display_name: 'display_name',
      remarks: 'notes',
      menu_settings: 'menu setting',
      notice_text:
        '※モバイルオーダーの表示名、説明は、 <br />　日本語以外の言語を選択し、その言語が未設定の場合、 <br />　英語が表示されます。 <br />',
      register_information: '〇レジ情報',
      menu_name: 'menu name',
      menu_type: ' menu type',
      display_timing: 'display timing',
      menu_property: 'menu property',
      menu_image: 'image',
      explanation: 'explanation',
      note1: 'note1',
      note2: 'note2',
      not_obtained: '未取得',
    },
    Table: {
      date_of_expired: 'date of expired',
      start: 'start',
      end: 'end',
      pos_cd: 'pos code',
      pos_name: 'pos name',
      amount_of_money_excluding_tax: 'amount of money excluding tax',
      amount_of_money_including_tax: 'amount of money<br />（including tax） <br />※レジデータ取 <br />込から取得',
    },
  },
};
